import { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import NoHistoryView from "../NoHistoryView";
import iIcon from "../../../../../assets/icons/i icon.svg";
import { formatDate } from "../../../../../functions/dateTime/formatDate";
import VehicleHistoryDialog from "./VehicleHistoryDialog";
import Modal from "../../../../../components/portal/Modal";

function VehicleHistoryList() {
  const { history } = useSelector((state) => state.data.data);
  const [dialogDetails, setDialogDetails] = useState({});
  const [activeDialog, setActiveDialog] = useState(null);
  const [clickedImage, setClickedImage] = useState(null);

  // --- View Handlers ---

  const handleDialogClick = useCallback((type, data) => {
    setDialogDetails({ type: type, data: data });
    setActiveDialog("history");
  }, []);

  const handleImageView = (picture) => {
    setClickedImage(picture);
    setActiveDialog("imageView");
  };

  const handleCloseImageView = () => {
    setActiveDialog("history");
  };

  return (
    <>
      {history?.length ? (
        <div className="cy-vehicle-history-wrap hides-scrollbar">
          {history.map((item, ind) => (
            <div
              key={ind}
              className={`relative pl-4 border-l-4 ${
                ind === history.length - 1 ? "" : "border-[#0F6FDF]"
              }`}
            >
              <p className="cy-history-blue-dot top-0"></p>
              <div className="pb-4">
                <div className="cy-history-box-gray">
                  <div className="cy-history-state-head">
                    <p className="text-dark-blue font-medium">
                      {formatDate(item.date)}
                    </p>
                    <p className="text-lb5">
                      Total: {item.load.length + item.unload.length}
                    </p>
                  </div>
                  <div className="px-3 py-2 space-y-2">
                    {["Load", "Unload"].map((type) => (
                      <div key={type} className="flex items-center">
                        <p>
                          {type}: {item[type.toLowerCase()].length}
                        </p>
                        {item[type.toLowerCase()].length > 0 && (
                          <img
                            src={iIcon}
                            alt="i icon"
                            className="ml-2 cursor-pointer blue-filterImg"
                            onClick={() =>
                              handleDialogClick(type, item[type.toLowerCase()])
                            }
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
          {activeDialog === "history" && (
            <VehicleHistoryDialog
              setActiveDialog={setActiveDialog}
              dialogDetails={dialogDetails}
              handleImageView={handleImageView}
            />
          )}
        </div>
      ) : (
        <NoHistoryView msg="No Vehicle History Available..!" />
      )}

      {/* ------------------------------- Cylinder Image view --------------------------------- */}
      {activeDialog === "imageView" && (
        <Modal
          closeDialog={handleCloseImageView}
          modalWidth="max-w-xl w-11/12 p-4"
        >
          <img src={clickedImage} alt="cylinder" className="w-full" />
        </Modal>
      )}
    </>
  );
}

export default VehicleHistoryList;
